import React from 'react';


const Modal = ({ isOpen, onClose,children,title }) => {
  if (!isOpen) return null;
  return (
    <div className={`modal fade ${isOpen ? 'show' : ''}`}
    id="exampleModal"
    tabIndex="-1"
    role="dialog"
    aria-labelledby="exampleModalLabel"
    aria-hidden="false"
    style={{ display: isOpen ? 'block' : 'none' }}>
                                        <div className="modal-dialog modal-dialog-centered" role="document">
                                            <div className="modal-content">
                                                <div className="modal-header">
                                                    <h5 className="modal-title">{title}</h5>
                                                    <button type="button" className="btn-close" data-bs-dismiss="modal" onClick={onClose}>
                                                    </button>
                                                </div>
                                                <div className="modal-body">
                                                   {children}
                                                </div>
                                                {/* <div className="modal-footer">
                                                    <button type="button" onClick={onClose} className="btn btn-danger light" data-bs-dismiss="modal">Close</button>
                                                    <button type="button" className="btn btn-primary">Save changes</button>
                                                </div> */}
                                            </div>
                                        </div>
                                    </div>
  );
};

export default Modal;
